export default __webpack_public_path__ + "static/media/logo.9d8755a7.png";